<template>
	<div>
		<span v-if="cadastroNovo && !visualizar">
			<i class="icon icon-solicitacao_nova_solicitacao icon-sub"></i>
			<h3>{{ _traducao('global', 'novo').toUpperCase() }}</h3>
		</span>
		<span v-else-if="visualizar">
			<i class="icon fa icon-vizualizar icon-sub"></i>
			<h3>{{ _traducao('global', 'visualizar').toUpperCase() }}</h3>
		</span>
		<span v-else>
			<i class="icon icon-editar icon-sub"></i>
			<h3>{{ _traducao('global', 'editar').toUpperCase() }}</h3>
		</span>
	</div>
</template>

<script>
export default {
	props: {
		cadastroNovo: {
			type: Boolean,
			required: true
		},
		visualizar: {
			type: Boolean,
			default: false
		}
	}
}
</script>
